<div class="unlink-coc-dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">link_off</mat-icon>
      <h2 mat-dialog-title class="dialog-title">
        {{ 'Unlink from Chain of Custody' | translate }}
      </h2>
    </div>
    <button mat-icon-button class="close-button" (click)="onCancel()" [disabled]="isLoading">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="confirmation-message">
      {{ 'This will remove Sample' | translate }} <strong>#{{ data.sampleNumber }}</strong> {{ 'from COC' | translate }} <strong>{{ data.labReqNumber }}.</strong><br>
      {{ 'The sample will return to an unassigned state and can be added to a different COC.' | translate }}<br>
    </p>
    <p class="audit-note">{{ 'This action is recorded in the audit trail.' | translate }}</p>

    @if (errorMessage) {
      <div class="error-message">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="onCancel()" [disabled]="isLoading" class="cancel-button">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="onUnlink()"
      [disabled]="isLoading"
      class="unlink-button">
      @if (isLoading) {
        <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      }
      @if (!isLoading) {
        <mat-icon>link_off</mat-icon>
      }
      <span class="button-text">{{ 'Unlink' | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
